import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33331 5.83329C3.33331 4.82077 4.15412 3.99996 5.16665 3.99996H5.99998C6.27612 3.99996 6.49998 4.22382 6.49998 4.49996C6.49998 4.7761 6.27612 4.99996 5.99998 4.99996H5.16665C4.70641 4.99996 4.33331 5.37305 4.33331 5.83329V11.5C4.33331 11.9602 4.7064 12.3333 5.16665 12.3333H10.8333C11.2936 12.3333 11.6666 11.9602 11.6666 11.5V5.83329C11.6666 5.37305 11.2936 4.99996 10.8333 4.99996H9.99998C9.72384 4.99996 9.49998 4.7761 9.49998 4.49996C9.49998 4.22382 9.72384 3.99996 9.99998 3.99996H10.8333C11.8459 3.99996 12.6666 4.82078 12.6666 5.83329V11.5C12.6666 12.5125 11.8459 13.3333 10.8333 13.3333H5.16665C4.15413 13.3333 3.33331 12.5125 3.33331 11.5V5.83329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66665 3.66663C6.5746 3.66663 6.49998 3.74125 6.49998 3.83329V4.83329C6.49998 4.92534 6.5746 4.99996 6.66665 4.99996H9.33331C9.42536 4.99996 9.49998 4.92534 9.49998 4.83329V3.83329C9.49998 3.74124 9.42536 3.66663 9.33331 3.66663H6.66665ZM5.49998 3.83329C5.49998 3.18896 6.02232 2.66663 6.66665 2.66663H9.33331C9.97766 2.66663 10.5 3.18897 10.5 3.83329V4.83329C10.5 5.47762 9.97766 5.99996 9.33331 5.99996H6.66665C6.02232 5.99996 5.49998 5.47762 5.49998 4.83329V3.83329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99998 8.16663C5.99998 7.89048 6.22384 7.66663 6.49998 7.66663H9.49998C9.77612 7.66663 9.99998 7.89048 9.99998 8.16663C9.99998 8.44277 9.77612 8.66663 9.49998 8.66663H6.49998C6.22384 8.66663 5.99998 8.44277 5.99998 8.16663Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99998 10.1666C5.99998 9.89048 6.22384 9.66663 6.49998 9.66663H9.49998C9.77612 9.66663 9.99998 9.89048 9.99998 10.1666C9.99998 10.4428 9.77612 10.6666 9.49998 10.6666H6.49998C6.22384 10.6666 5.99998 10.4428 5.99998 10.1666Z"
      fill="currentColor"
    />
  </SvgIcon>
));
